import { render, staticRenderFns } from "./metasVenta.vue?vue&type=template&id=31760677&scoped=true"
import script from "./metasVenta.vue?vue&type=script&lang=js"
export * from "./metasVenta.vue?vue&type=script&lang=js"
import style0 from "./metasVenta.vue?vue&type=style&index=0&id=31760677&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31760677",
  null
  
)

export default component.exports